
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import{
		getSearchDate,
		nextDay
	} from "@/utils/index"
	import PickerDate from '@/components/picker-date.vue';
	import {
		providerSelectItem
	} from '@/api/supplier';
  import {
    productSettlementlist,
    productSettlementrefreshSettleFreightMoney,
    productSettlementcalculateInfo
  } from '@/api/order'
	import {
		UserModule
	} from "@/store/modules/user"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private filterTime = getSearchDate(2,false,-1)
    private keywords = ''
    private suppliers = null
    private supplierslist:any = []
    private tablelist:any = []
    private totallist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private settle = null
    private settlelist = [
      {value:null,label:'全部'},
      {value:1,label:'大货'},
      {value:2,label:'散单'},
    ]
    private supplierTypes = [
      {value:null,label:'全部'},
      {value:1,label:'服务合同'},
      {value:2,label:'购销合同'},
    ];
    private supplierType = null;
    private result:any = {
      SettleFreightCalculateStateValue:'进行中',
      SettleFreightCalculateTime:null
    }
    private timer:any = ''

    get userId(){
      return Number(UserModule.mallInfo.EmployeeId)
    }
    private mounted () {
      this.getSupplierList()
      this.gettablelist()
      this.getresult()
    }
    private beforeDestroy () {
      clearInterval(this.timer)
    }
    private async getresult(){
      try{
        let res = await productSettlementcalculateInfo({})
        if(res.IsSuccess){
          this.result = res.Result
          if(!this.timer){
            this.continue()
          }
        }
      }finally{
        //
      }
    }
    private continue(){
      this.timer = setInterval(() => {
        this.getresult()
      }, 5000);
    }
    private async refreshSettleData(){
      try{
        await productSettlementrefreshSettleFreightMoney({})
        this.getresult()
      }finally{
        this.gettablelist()
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          ProviderId:this.suppliers,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          SettleOrderType:this.settle,
          ProviderContractType: this.supplierType
        }
        if (this.filterTime&&this.filterTime.length) {
          var dt = this.filterTime
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await productSettlementlist(data)
        if(res.IsSuccess){
          this.totallist = [res.Result.TotalStatistic]
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.pageNo = 1
      this.keywords = ''
      this.filterTime = getSearchDate(2,false,-1)
      this.suppliers = null
      this.settle = null
      this.supplierType = null;
      this.gettablelist()
    }
    private exportExcel(){
      let url = location.origin + '/pc/order/productSettlement/list'
      url += '?Keywords=' + this.keywords
      url += '&ProviderId=' + (this.suppliers||'')
      url += '&SettleOrderType=' + (this.settle||'')
      url += '&ProviderContractType=' + (this.supplierType || '')
      if (this.filterTime&&this.filterTime.length) {
        var dt = this.filterTime
        url += '&StartTime=' + (dt[0]||'')
        url += '&EndTime=' + (nextDay(dt[1],1)||'')
      }
      window.open(url)
    }
    // 获取供应商列表
		private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplierslist = res.Result.map(v => {
					return {
						value: v.Id,
						label: v.ProviderName
					}
				})
			} catch (e) {
				console.log('supplierList ===>', e);
			}
		}
  }
